module.exports = "<sui-modal [(visible)]=\"showDialog\" headerText=\"Sample Modal\">\r\n    <button (click)=\"showDialog = !showDialog\" class=\"sui-btn\">Close</button>\r\n</sui-modal>";


//////////////////
// WEBPACK FOOTER
// ./src/app/samples/sample.modal/sample.modal.component.html
// module id = 420
// module chunks = 0